/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// Some of the code comes from WebComponents.JS
// https://github.com/webcomponents/webcomponentsjs/blob/master/src/HTMLImports/path.js

import {isBlank, isPresent} from './facade/lang';

import {UrlResolver} from './url_resolver';

export class StyleWithImports {
/**
 * @param {?} style
 * @param {?} styleUrls
 */
constructor(public style: string,
public styleUrls: string[]) {}
}

function StyleWithImports_tsickle_Closure_declarations() {
 /** @type {?} */
StyleWithImports.prototype.style;
 /** @type {?} */
StyleWithImports.prototype.styleUrls;
}

/**
 * @param {?} url
 * @return {?}
 */
export function isStyleUrlResolvable(url: string): boolean {
  if (isBlank(url) || url.length === 0 || url[0] == '/') return false;
  const /** @type {?} */ schemeMatch = url.match(_urlWithSchemaRe);
  return schemeMatch === null || schemeMatch[1] == 'package' || schemeMatch[1] == 'asset';
}
/**
 *  Rewrites stylesheets by resolving and removing the @import urls that
  * are either relative or don't have a `package:` scheme
 * @param {?} resolver
 * @param {?} baseUrl
 * @param {?} cssText
 * @return {?}
 */
export function extractStyleUrls(
    resolver: UrlResolver, baseUrl: string, cssText: string): StyleWithImports {
  const /** @type {?} */ foundUrls: string[] = [];
  const /** @type {?} */ modifiedCssText = cssText.replace(_cssImportRe, function(...m: string[]) {
    const /** @type {?} */ url = m[1] || m[2];
    if (!isStyleUrlResolvable(url)) {
      // Do not attempt to resolve non-package absolute URLs with URI scheme
      return m[0];
    }
    foundUrls.push(resolver.resolve(baseUrl, url));
    return '';
  });
  return new StyleWithImports(modifiedCssText, foundUrls);
}

const /** @type {?} */ _cssImportRe = /@import\s+(?:url\()?\s*(?:(?:['"]([^'"]*))|([^;\)\s]*))[^;]*;?/g;
const /** @type {?} */ _urlWithSchemaRe = /^([^:/?#]+):/;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
